import RecipeCreate from '../components/Recipe/RecipeCreate';
import { RecipeEdit } from '../components/Recipe/RecipeEdit';

export const Recipes = {
  create: RecipeCreate,
  edit: RecipeEdit
};
